import { useLangCtx } from '../context/LangContext';
import { removeSpecialCharacters } from '../helpers/removeSpecialCharacters';

function useTranslations() {
    const { dictionary } = useLangCtx();

    const t = (key = '', defaultValue = '') => {
        key = removeSpecialCharacters(String(key));

        key = key?.toUpperCase().trim();
        return dictionary?.[key] || defaultValue;
    };
    return {
        t,
    };
}

export default useTranslations;
